var _desc, _rect, _rect2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBekiosk = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: 1024,
    height: 1024,
    role: "img",
    "aria-label": "BEKIOSK",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BEKIOSK") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Logo compact de la suite BE : Be. et kiosk, carr\xE9 arrondi.")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    rx: 128,
    fill: "#1B2C31"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 46,
    width: 932,
    height: 932,
    rx: 84,
    fill: "#E3ADA6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "be-signature",
    transform: "scale(1.024)",
    fill: "#1B2C31",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130 150H348C435 150 484 193 484 263C484 311 461 345 422 365C478 382 502 420 502 478C502 555 444 600 351 600H130Z M228 232V325H327C362 325 381 308 381 278C381 248 361 232 330 232Z M228 404V505H338C377 505 399 486 399 454C399 423 377 404 337 404Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815 470H594C600 511 624 535 663 535C694 535 714 523 725 506H811C790 577 738 612 660 612C557 612 503 548 503 445C503 340 563 267 665 267C759 267 815 331 815 438Z M595 405H720C716 364 696 340 665 340C629 340 605 363 595 405Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826 505H918V600H826Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "application-name",
    fill: "#1B2C31",
    transform: "translate(60.637068 919.593376) scale(0.30725863 -0.30725863)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0.000 0)",
    d: "M239 90 244 356 433 547H700L450 285L337 194ZM50 0V742H276V0ZM445 0 295 190 434 361 718 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(676.000 0)",
    d: "M50 0V547H276V0ZM163 591Q101 591 64.0 624.0Q27 657 27 706Q27 755 64.0 788.0Q101 821 163 821Q225 821 262.0 790.0Q299 759 299 710Q299 658 262.0 624.5Q225 591 163 591Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(977.000 0)",
    d: "M339 -10Q246 -10 174.5 26.5Q103 63 62.0 127.0Q21 191 21 274Q21 357 62.0 421.0Q103 485 174.5 521.0Q246 557 339 557Q432 557 504.0 521.0Q576 485 616.5 421.0Q657 357 657 274Q657 191 616.5 127.0Q576 63 504.0 26.5Q432 -10 339 -10ZM339 166Q364 166 384.0 178.0Q404 190 416.0 214.5Q428 239 428 274Q428 310 416.0 333.5Q404 357 384.0 369.0Q364 381 339 381Q314 381 294.0 369.0Q274 357 262.0 333.5Q250 310 250 274Q250 239 262.0 214.5Q274 190 294.0 178.0Q314 166 339 166Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(1630.000 0)",
    d: "M264 -10Q194 -10 126.0 5.0Q58 20 16 44L78 193Q117 170 168.5 157.0Q220 144 269 144Q310 144 324.5 151.0Q339 158 339 170Q339 182 322.0 187.5Q305 193 277.0 196.0Q249 199 215.5 203.5Q182 208 148.0 217.0Q114 226 86.0 244.0Q58 262 41.0 292.5Q24 323 24 370Q24 422 55.5 464.0Q87 506 149.5 531.5Q212 557 304 557Q364 557 424.0 546.0Q484 535 527 512L465 363Q423 386 382.5 394.5Q342 403 307 403Q264 403 248.5 395.0Q233 387 233 377Q233 365 250.0 359.0Q267 353 295.0 350.0Q323 347 356.5 342.5Q390 338 423.5 328.5Q457 319 485.0 301.0Q513 283 530.0 252.5Q547 222 547 175Q547 126 516.0 83.5Q485 41 422.0 15.5Q359 -10 264 -10Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(2170.000 0)",
    d: "M239 90 244 356 433 547H700L450 285L337 194ZM50 0V742H276V0ZM445 0 295 190 434 361 718 0Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBekiosk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bekiosk.06f0090b6c2547e5243b8aee0b6c0c0d.svg";